<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
    :is-required="isRequired"
    :form-class-name="formClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <star-rating
        v-model="ratingValue"
        active-color="#1BB2B1"
        inactive-color="#FFFFFF"
        :star-size="25"
        :border-width="2"
        :rounded-corners="true"
        :show-rating="false"
        :read-only="readOnly"
        data-test="star-rating"
      />
    </template>
    <template #error>
      <slot name="error" />
      <validation-label
        v-if="validation.isShow"
        data-test="error"
        :label="validation.message"
      />
    </template>
  </form-label>
</template>

<script>
import FormLabel from '@/components/atoms/FormLabel'
import StarRating from 'vue-star-rating'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    FormLabel,
    StarRating,
    ValidationLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    rating: {
      type: Number,
      default: 0
    },
    isRequired: {
      default: false,
      type: Boolean
    },
    formClassName: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    validation () {
      return {
        isShow: this.ratingValue === 0,
        message: '「★」を１つ以上選択してください'
      }
    },
    ratingValue: {
      get () {
        return this.rating
      },
      set (val) {
        this.$emit('update:rating', val)
      }
    }
  }
}
</script>
